/* eslint-disable import/no-default-export */
import React from 'react';

import VoteIcon from '../../icons/VoteIcon';

import IconBadge from './IconBadge';

const VotesBadge = ({ numVotes = 0, voted = false }) => (
  <IconBadge
    bgColor={voted ? 'N40A' : 'transparent'}
    fontColor="N100"
    icon={<VoteIcon />}
  >
    {numVotes}
  </IconBadge>
);

export default VotesBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/VotesBadge.js